import React, { useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import { useAppContext } from "../../context";
import {
  useGetCitiesQuery,
  useGetProductsQuery,
  useLazyGetRatesByProductQuery,
} from "../../store/api/conversionApi";
import { getRatesData } from "../../Functions";

export default function SelectComponent({ isMobile }: { isMobile: boolean }) {
  const { isCash, setCurrentRateData, setOfficialCourse, setTableTitle, city, setCity, product, setProduct, tab, selectDisabled, setSelectDisabled } = useAppContext();

  const { data: cities = [] } = useGetCitiesQuery();
  const { data: products = [] } = useGetProductsQuery(isCash);


// const isInitialLoad  =
//   tab === 2 ||
//   product === null ||
//   product === undefined;


const [
  triggerRates,
  { data: rates }
] = useLazyGetRatesByProductQuery();

useEffect(() => {
  if (tab === 2) return;

  triggerRates({
    isCash: tab === 0,
  });
}, [tab, triggerRates]);

const fetchRates = () => {
  if (tab === 2) return;

  triggerRates({
    isCash: tab === 0,
    ...(product ? { RateProductID: product } : {}),
    ...(city ? { RateCityID: city } : {}),
  });
};


useEffect(() => {
  if (tab === 2) return;

  const intervalId = setInterval(() => {
    fetchRates();
  }, 60_000); // 1 წუთი

  return () => clearInterval(intervalId);
}, [tab, product, city]);


useEffect(() => {
  if (!rates) return;

  const hasNbgRate = rates.some((r: any) => Boolean(r?.NBGRate));
  setOfficialCourse(hasNbgRate);

  const data = getRatesData(rates);
  setCurrentRateData(data);
}, [rates, setOfficialCourse, setCurrentRateData]);


// useEffect(() => {
//   if (!products?.length || product) return;

//   const defaultProduct = products.find(p => p.IsDefault);
//   if (defaultProduct) {
//     setProduct(defaultProduct.ID);
//     setTableTitle(defaultProduct.RateProduct);
//   }
// }, [products, product, setProduct, setTableTitle]);

// useEffect(() => {
//   if (!cities?.length || city !== null) return;
//   setCity(1);
// }, [cities, city, setCity]);



  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        gap: 2,
        mt: 3,
        width: "100%",
      }}
    >
      <FormControl size="small" sx={{ width: { xs: "100%", sm: 190 } }} disabled={selectDisabled}>
        <InputLabel shrink={!selectDisabled}>ქალაქი</InputLabel>
        <Select

          label={!selectDisabled ? "ქალაქი" : ''}
          value={!selectDisabled && city}
          onChange={(e) => {
            const value = Number(e.target.value);
            setCity(value)

          }}
          MenuProps={{
            PaperProps: {
              sx: { maxHeight: 240, overflowY: "auto" },
            },
          }}
        >
          {cities?.map((c: any) => (
            <MenuItem key={c.ID} value={c.ID}>
              {c.City}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl
      focused   
        size="small"
        sx={{
          width: { xs: "100%", sm: 190 },
        }}
      >
        <InputLabel shrink>
          კურსების ჩამონათვალი
        </InputLabel>

        <Select
        
          label="კურსების ჩამონათვალი"
          value={product ? product : products.find(p => p.IsDefault)?.ID || ''}
          onChange={(e) => {
            const value = Number(e.target.value);
            setProduct(value);
            setTableTitle(
              products.find(p => p.ID === value)?.RateProduct || ""
            );
            setSelectDisabled(!products.find(p => p.ID === value)?.HasChildDropdown || false);
            setCity(products.find(p => p.ID === value)?.IsDefault ? null : cities[0]?.ID || null);
          }}
          MenuProps={{
            PaperProps: {
              sx: { maxHeight: 240, overflowY: "auto" },
            },
          }}
        >
          {products.map((p: any) => (
            <MenuItem key={p.ID} value={p.ID}>
              {p.RateProduct}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

    </Box>
  );
}
